<div class="modal-fixed-container mail-template-edit-on-status">
  <div class="modal-dialog">
    <!-- <ng-container *ngIf="isLoading">
      <div [class]="isLoading?'page-loader':'page-loder d-none'"></div>
    </ng-container> -->
    <div class="modal-content" [ngClass]="{'hide-parent':isSecondModel}">
      <div class="modal-header">
        <!-- <h4 class="modal-title">Send Email</h4> -->
        <h4 class="modal-title">{{titleName ? titleName : 'Send Email'}}</h4>
        <div class="back-button" *ngIf="isDisplayAddRecipientOption">
          <a class="back" (click)="toggleRecipients()"><u>Add Recipients</u>
          </a>
        </div>
      </div>
      <div class="modal-body">
        <div class="modal-body-inner">
          <div *ngIf="isDisplayRecipient">
            <form [formGroup]="emailForm">
              <div class="free-order-address address-item-box">
                <div class="address-box-inner">
                  <label class="side-panel-sample-lable">Add Recipients</label>
                  <div class="recipient-emails-container row" formArrayName="emails">
                    <div *ngFor="let value of emailsArray().controls; let idx=index"
                         [formGroupName]="idx">
                      <div class="col-12 form-group">
                        <input type="email"
                               class="form-control side-panel-sample-field recipient_emails"
                               formControlName="email" [ngClass]="{ 'is-invalid': (fe?.controls[idx].get('email')?.invalid && fe?.controls[idx].get('email')?.touched || submitted) || fe?.controls[idx].get('email')?.errors?.apiError,
                     'is-valid' : !(fe?.controls[idx].get('email')?.invalid)}">
                        <span class="secondary-email-icon" (click)="removeNewEmail(idx)"
                              *ngIf="idx != 0">-</span>
                        <span class="invalid-feedback" role="alert"
                              *ngIf="(fe?.controls[idx].get('email')?.invalid && (fe?.controls[idx].get('email').touched || submitted)) || fe?.controls[idx].get('email')?.errors?.apiError">
                                                    <span *ngIf="fe?.controls[idx].get('email')?.errors?.required">Enter the email address.</span>
                                                    <span *ngIf="fe?.controls[idx].get('email')?.errors?.pattern">Enter the valid email address.</span>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="checkbox-box" (click)="addNewEmail()"
                     *ngIf="emailsArray().controls.length < 5">
                  <span class="checkbox-custom"></span>
                </div>
              </div>
            </form>
          </div>
          <div class="email_section">
            <body style='background-color: #F5F5F7; margin: 0;font-family: Segoe UI,Helvetica,Ubuntu,sans-serif;'>
              <table style='width: 100%; background: #fff; border-collapse: collapse;max-width: 640px; margin: 0 auto; border: none;' cellspacing='0' cellpadding='0' width='100%'>
                <tr style="background: #40554A;">
                    <td style='text-align: center;padding: 25px 15px 25px;border-bottom: 1px solid #40554A; background: #40554A;' align='center'>
                        <a  style='display: inline-block; text-decoration: none; outline: none; border: none; box-shadow: inherit; vertical-align: middle; padding: 0; margin: 0; max-width: 330px;' target='_blank' title='Great Non Profits'>
                          <img src="../../../assets/admin/images/gatherco-logo.png" alt="GatherCo Logo" style="width: 233px;vertical-align: middle;height: 70px;display: block;object-fit: contain;">
                        </a>
                    </td>
                </tr>
                  <tr>
                      <td style='text-align: center;padding: 30px;border-bottom: none;'>
                          <img src="../../../assets/admin/images/banner-img.png" alt="IMG" style="width: 100%;vertical-align: middle;height: auto;display: block;object-fit: contain;">
                      </td>
                  </tr>

                  <!-- Email Template Title -->
                <tr>
                  <td style='text-align: left;' align='left'>
                    <div style="position: relative; display: inline-block; width: 100%; " class="title-zone email_title_section">
                      <!-- Gallery Edit Box -->
                      <div class="gallery-edit-box" style="position: absolute; top: 0; right: 0;">
                        <a href="javascript:void(0)" class="edit-icon" (click)="titleUpdate()">
                          <img src="{{constant.S3_BUCKET_URL}}/gallery-images-edit-icon.svg" width="40%" alt="icon">
                        </a>
                      </div>
                       <!-- Main Content -->
                       <h2 style='font-size: 28px; line-height: 40px; font-weight: 400; color: #111111; margin: 0; font-family: Segoe UI, Helvetica, Ubuntu, sans-serif;padding: 0 30px 30px;'>
                        <strong style='color: #111111; font-weight: 700;'> {{ emailModel?.title }}</strong>
                      </h2>
                    </div>
                  </td>
                </tr>
              <tr >
                 <td style="position: relative;text-align: left; padding: 0px">
                      <div class="title-zone body-edit-box">
                        <div class="gallery-edit-box body-edit-box">
                          <a href="javascript:void(0)" class="edit-icon" (click)="bodyUpdate()">
                            <img src="{{constant.S3_BUCKET_URL}}/gallery-images-edit-icon.svg" width="40%" alt="icon">
                          </a>
                        </div>
                        <table style="width: 100%;">
                          <tbody [innerHTML]="sanitizer.bypassSecurityTrustHtml(emailModel?.body)"></tbody>
                        </table>
                      </div>
                    </td>
                  </tr>

                <!-- Email Template Footer -->
                  <tr>
                      <td style='text-align: left;padding: 0px 30px 30px;' align='left'>
                          <p style='font-size: 16px;line-height: 22px;font-weight: 400;color:#111111;margin:0;font-family: Segoe UI,Helvetica,Ubuntu,sans-serif;'>Regards,</p>
                          <p style='font-size: 16px;line-height: 22px;font-weight: 400;color:#111111;margin:0;font-family: Segoe UI,Helvetica,Ubuntu,sans-serif;'>GatherCo Team</p>
                      </td>
                  </tr>

                  <tr>
                      <td style='text-align: center;padding:0 30px 30px; background: #ffffff' align='center'>
                          <table cellspacing='0' cellpadding='0' width='100%'>
                              <tbody>
                              <tr>
                                  <td style="padding: 20px;background: #F5F5F7;">
                                      <p style='font-size: 16px;line-height: 22px;font-weight: 500;color:#111111;margin:0 0 20px;padding: 0;font-family: Segoe UI,Helvetica,Ubuntu,sans-serif;'>We're excited for you to explore our Instagram page!</p>
                                      <a [href]="constant.SOCIAL_MEDIA_URLS.INSTAGRAM" target="_blank" style="background: #40554A;font-size: 16px;line-height: 22px;font-weight: 400;color:#ffffff;margin:0;font-family: Segoe UI,Helvetica,Ubuntu,sans-serif;padding: 12px 20px;display: inline-block;text-decoration: none;">
                                          <img src="../../../assets/admin/images/instagram-white-icon.png" width="18" height="18" alt="Instagram" style="width: 18px;vertical-align: middle;height: auto;display: inline-block;object-fit: contain;margin: -3px 10px 0 0;">
                                          Follow GatherCo on Instagram
                                      </a>
                                  </td>
                              </tr>
                              </tbody>
                          </table>
                      </td>
                  </tr>

                <tr>
                    <td style='padding: 20px 40px 0; background: #FAF6F0; text-align: center; border-top: 2px solid #D3A02A;'>
                        <table style='width: 100%; border-collapse: collapse;min-width: 100%;' cellspacing='0' cellpadding='0' width='100%'>
                            <tr>
                              <td style='text-align: left; padding:0;width: 27%;' align='left'>
                                  <a [href]="constant.FRONTEND_LINKS.PRIVACY_POLICY" target="_blank" style="font-size: 14px;font-weight: 400;line-height: 22.4px;color: #111111; text-decoration: underline">Privacy Policy</a>
                              </td>
                                <td style='text-align: center; padding:0;border-left: 1px solid #D9D9D9;border-right: 1px solid #D9D9D9;width: 46%;' align='center'>
                                    <a [href]="constant.FRONTEND_LINKS.TERMS_AND_CONDITIONS" target="_blank" style="font-size: 14px;font-weight: 400;line-height: 22.4px;color: #111111; text-decoration: underline">Terms & Conditions</a>
                                </td>
                                <td style='text-align: right; padding:0;width: 27%;' align='right'>
                                    <a [href]="constant.FRONTEND_LINKS.CONTACT_US" target="_blank" style="font-size: 14px;font-weight: 400;line-height: 22.4px;color: #111111; text-decoration: underline">Contact Us</a>
                                </td>
                            </tr>
                            <tr>
                              <td colspan="3" style='padding: 30px 0;text-align: center;' align='center'>
                                  <table style='width:100%; max-width:183px;margin:0 auto;border-collapse:collapse;' cellspacing='0' cellpadding='0' width='100%'>
                                      <tr>
                                            <td style='padding: 0 10px 0 0; text-align: center;' align='center' valign='middle'>
                                                <a [href]="constant.SOCIAL_MEDIA_URLS.FACEBOOK" target= 'blank' style='line-height: 0;border: 1px solid #D9D9D9;outline: none;text-decoration: none; width: 42px; height: 42px; background: transparent; display: inline-block; border-radius: 0; box-sizing: border-box;padding: 8px;' title='Facebook'>
                                                    <img src='../../../assets/admin/images/facebook.png' alt='Facebook' style='width: 24px;height: 24px;vertical-align:middle;' width='24' height='24'>
                                                </a>
                                            </td>
                                            <td style='padding: 0 10px 0 0; text-align: center;' align='center' valign='middle'>
                                                <a [href]="constant.SOCIAL_MEDIA_URLS.INSTAGRAM" target='_blank' style='line-height: 0;border: 1px solid #D9D9D9;outline: none;text-decoration: none; width: 42px; height: 42px; background: transparent; display: inline-block; border-radius: 0;box-sizing: border-box;padding: 8px;' title='Instagram'>
                                                    <img src='../../../assets/admin/images/instagram.png' alt='Instagram' style='width: 24px;height: 24px;vertical-align:middle;' width='24' height='24'>
                                                </a>
                                            </td>
                                            <td style='padding: 0 10px 0 0; text-align: center;' align='center' valign='middle'>
                                                <a [href]="constant.SOCIAL_MEDIA_URLS.PINTEREST" target='_blank' style='line-height: 0;border: 1px solid #D9D9D9;outline: none;text-decoration: none; width: 42px; height: 42px; background: transparent; display: inline-block; border-radius: 0;box-sizing: border-box;padding: 8px;' title='Pinterest'>
                                                    <img src='../../../assets/admin/images/pinterest.png' alt='Pinterest' style='width: 24px;height: 24px;vertical-align:middle;' width='24' height='24'>
                                                </a>
                                            </td>
                                      </tr>
                                  </table>
                              </td>
                          </tr>
                          <tr>
                            <td colspan="3" style='text-align: center;padding: 15px 0;border-top: 1px solid #D9D9D9' align='center'>
                                <p style='font-size: 14px;line-height: 22px;color: #111111;font-weight: 400;margin: 0;font-family: Segoe UI,Helvetica,Ubuntu,sans-serif;text-align:center;'>Copyright © {{ currentYear }} GatherCo. All rights reserved.</p>
                            </td>
                          </tr>
                        </table>
                    </td>
                </tr>
            </table>
            </body>
          </div>
        </div>
      </div>
      <div class="modal-footer mt-2">
        <div class="availibility-check custom-label-checkbox">
          <input type="checkbox" id="is_send_copy_to_sales_representative" (change)="onChange($event)"
                 [checked]="isSendCopyToSalesRepresentative"/>
          <label class=" dark-grey-label">
            Send copy to Sales Representative?
          </label>
        </div>
        <button type="button" class="dark-bordered-btn dont-send-btn" data-dismiss="modal"
                (click)="cancel()">Don't Send
        </button>
        <button type="button" class="submit-btn-grey status-modal-save" (click)="onSubmit()">Send
        </button>
      </div>
    </div>
  </div>
</div>
